document.addEventListener('DOMContentLoaded', () => {
  const initPolicyContent = () => {
    const sections = [...document.querySelectorAll('[data-policy-content]')];
    const header = document.querySelector('[data-main-header]');
    if (sections.length === 0 || !header) return;

    // The sticky sidebar has to clear the sticky header, but the header is
    // padding-sized rather than a fixed height, so its height is only knowable
    // at runtime. Same approach as --drawer-top in header-javascript.js.
    const publishHeaderHeight = () => {
      const { height } = header.getBoundingClientRect();
      for (const section of sections) {
        section.style.setProperty('--polcontent-header-h', `${Math.round(height)}px`);
      }
    };

    publishHeaderHeight();
    new ResizeObserver(publishHeaderHeight).observe(header);
  };

  initPolicyContent();
  document.addEventListener('shopify:section:load', initPolicyContent);
});
